<template>
    <div>
    </div>
</template>

<script>
    import PaymentToolTime from "./PaymentToolTime";

    export default {
        name: 'auto-payment-composition',
        props: {},
        mixins: [PaymentToolTime],
    }
</script>

